import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FexidocLogo } from "./FexidocLogo";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/product", label: "Product" },
  { to: "/how-it-works", label: "How it works" },
  { to: "/templates", label: "Templates" },
  { to: "/solutions", label: "Solutions" },
  { to: "/security", label: "Security" },
  { to: "/pricing", label: "Pricing" },
];

export default function PublicNav() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 left-0 right-0 z-40 fx-glass border-b border-white/5">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-5 py-3">
        <Link to="/" data-testid="nav-home"><FexidocLogo /></Link>
        <nav className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g,'-')}`}
              className={`px-3 py-2 rounded-lg text-sm transition ${pathname.startsWith(l.to) ? "text-white bg-white/5" : "text-slate-400 hover:text-slate-100 hover:bg-white/5"}`}>
              {l.label}
            </Link>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-2">
          <Link to="/login" data-testid="nav-login" className="px-4 py-2 rounded-lg text-sm text-slate-300 hover:text-white hover:bg-white/5 transition">Sign in</Link>
          <Link to="/signup" data-testid="nav-signup" className="fx-btn-primary text-white text-sm font-medium px-4 py-2 rounded-lg">Start free</Link>
        </div>
        <button className="lg:hidden text-slate-200 p-2" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X size={20}/> : <Menu size={20} />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-white/5 px-5 py-3 space-y-1 fx-glass">
          {links.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="block px-3 py-2 rounded-lg text-slate-300 hover:bg-white/5">{l.label}</Link>
          ))}
          <Link to="/login" onClick={() => setOpen(false)} className="block px-3 py-2 rounded-lg text-slate-300 hover:bg-white/5">Sign in</Link>
          <Link to="/signup" onClick={() => setOpen(false)} className="block px-3 py-2 rounded-lg fx-btn-primary text-white text-center">Start free</Link>
        </div>
      )}
    </header>
  );
}

export function PublicFooter() {
  return (
    <footer className="border-t border-white/5 mt-24 py-12 bg-[#050816]">
      <div className="max-w-7xl mx-auto px-5 grid gap-8 md:grid-cols-4 text-sm text-slate-400">
        <div>
          <FexidocLogo />
          <p className="mt-3 max-w-xs">Your documents. Your standards. Automatically.</p>
        </div>
        <div>
          <div className="text-slate-200 font-medium mb-3">Product</div>
          <Link to="/product" className="block hover:text-white py-1">Overview</Link>
          <Link to="/how-it-works" className="block hover:text-white py-1">How it works</Link>
          <Link to="/templates" className="block hover:text-white py-1">Templates</Link>
          <Link to="/pricing" className="block hover:text-white py-1">Pricing</Link>
        </div>
        <div>
          <div className="text-slate-200 font-medium mb-3">Solutions</div>
          <Link to="/solutions" className="block hover:text-white py-1">All industries</Link>
          <Link to="/security" className="block hover:text-white py-1">Security</Link>
          <Link to="/contact" className="block hover:text-white py-1">Contact sales</Link>
        </div>
        <div>
          <div className="text-slate-200 font-medium mb-3">Legal</div>
          <Link to="/privacy" className="block hover:text-white py-1">Privacy</Link>
          <Link to="/terms" className="block hover:text-white py-1">Terms</Link>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-5 mt-10 pt-6 border-t border-white/5 text-xs text-slate-500">© {new Date().getFullYear()} Fexidoc. Document automation for modern teams.</div>
    </footer>
  );
}
